import { render, staticRenderFns } from "./inquiryDetail.vue?vue&type=template&id=6916653c&scoped=true&"
import script from "./inquiryDetail.vue?vue&type=script&lang=js&"
export * from "./inquiryDetail.vue?vue&type=script&lang=js&"
import style0 from "./inquiryDetail.vue?vue&type=style&index=0&id=6916653c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6916653c",
  null
  
)

export default component.exports